import I18n from 'I18n';
import createStandardI18nProvider from 'I18n/init/providers/createStandardI18nProvider';
import getLangLocale from 'I18n/utils/getLangLocale';
import { createAuthRegistry } from './registry';
import { initializeDefaults } from './defaults';

type I18nWithInternals = {
  langEnabled?: boolean;
};

function makeI18nLoader() {
  // Provider is created once per call. setLocale is called on the first
  // register() invocation so it runs at render-time (after app I18n bootstrap
  // in production). localeReady tracks whether setLocale has been called for
  // THIS provider instance — it resets on HMR and on clearRegistry() so we
  // never end up with an unresolved localePromise after module re-evaluation.
  let provider = createStandardI18nProvider();
  let localeReady = false;

  return {
    register: (lang: unknown) => {
      if (!localeReady) {
        const i18n = I18n as I18nWithInternals;
        try {
          provider.setLocale({
            locale: getLangLocale() || 'en-us',
            langEnabled: i18n.langEnabled ?? true,
          });
          localeReady = true;
        } catch {
          // setLocale failed; leave localeReady=false so next call retries
        }
      }
      return provider.register(lang);
    },
    reset: () => {
      provider = createStandardI18nProvider();
      localeReady = false;
    },
  };
}

const i18nLoader = makeI18nLoader();

export const defaultRegistry = createAuthRegistry({
  initializer: initializeDefaults,
  i18nLoader,
  onClear: () => i18nLoader.reset(),
});
